<template>
  <component
    :is="component"
    v-if="component"
    :filterData="filterData"
    :paginationData="paginationData"
    :category="category"
  />
</template>

<script>
export default {
  name: "SsamTalkFilterLink",
  mixins: [],
  components: {},
  provide() {
    return {};
  },
  props: {
    filterLayout: {},
    filterData: {
      default: () => {},
    },
    paginationData: {
      default: () => {
        return { total: 0, page: 0, size: 0 };
      },
    },
    category:[],
  },
  data() {
    return {
      component: null,
    };
  },
  created() {},
  mounted() {
    this.filterLoader();
  },
  beforeDestroy() {},
  destroyed() {},
  computed: {
    loader() {
      if (!this.filterLayout) {
        return null;
      }
      return () => import(`@/components/ssamtalk/layout/ssamtalkList/filter/${this.filterLayout}`);
    },
  },
  methods: {
    filterLoader() {
      this.loader()
        .then(() => {
          this.component = () => this.loader();
        })
        .catch(() => {
          this.component = () =>
            import("@/components/ssamtalk/layout/ssamtalkList/filter/SsamTalkFilterDefaultLayou");
        });
    },
  },
  watch: {},
};
</script>

<style scoped></style>
